import React, { useState, useEffect } from "react";
import Heders from "./Headers";
import Banner from "./Banner";
import { useMemo } from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const texts = useMemo(
    () => [
      "ابحث عن أفضل طبيب لك .",
      "اختر أقرب طبيب في مدينتك .",
      "احجز موعدك من المنزل .",
      "تتبع الموعد على ملفك الشخصي .",
      "تواصل مع الطبيب من ملفك الشخصي .",
    ],
    []
  );

  useEffect(() => {
    const typeSpeed = isDeleting ? 50 : 100;
    const delayBetweenTexts = 5000;
    const delayAfterDeletion = 2000;

    const handleTyping = () => {
      const currentText = texts[currentTextIndex];
      const textLength = displayedText.length;

      if (!isDeleting && textLength < currentText.length) {
        setDisplayedText(currentText.slice(0, textLength + 1));
      } else if (isDeleting && textLength > 0) {
        setDisplayedText(currentText.slice(0, textLength - 1));
      } else if (!isDeleting && textLength === currentText.length) {
        setTimeout(() => setIsDeleting(true), delayBetweenTexts);
      } else if (isDeleting && textLength === 0) {
        setIsDeleting(false);
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        setTimeout(() => {}, delayAfterDeletion);
      }
    };

    const typingTimer = setTimeout(handleTyping, typeSpeed);

    return () => clearTimeout(typingTimer);
  }, [displayedText, isDeleting, currentTextIndex, texts]);

  const handleButtonClick = () => {
    window.location.href = "/doctors";
  };

  return (
    <section className="hero">
      <Heders />

      <div className="px-24 py-16 lg:px-10 lg:py-10 sm:p-5 ">
        <div className="hero-content">
          {/* Left Section */}
          <div className="hero-left ">
            <div className="block justify-end text-right sm:text-center pr-5 sm:pr-0">
              <h2 className="hero-h2 ">احجز موعدًا مع أفضل </h2>
              <h1 className="hero-h1 pr-1">الأطباء الموثقين</h1>
            </div>
            <div className="text-right">
              <h2 className="animated-text mr-10 sm:mr-0" dir="rtl">
                {displayedText}|
              </h2>
            </div>
            <div className="flex justify-center items-center mt-10 sm:mt-5">
              <Link to="/doctors" className="flex justify-center items-center">
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc1.jpg`}
                  alt="doc1"
                  className="w-16 md:w-10 rounded-full shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc2.jpg`}
                  alt="doc2"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc3.jpg`}
                  alt="doc3"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc4.jpg`}
                  alt="doc4"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc5.jpg`}
                  alt="doc5"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc6.jpg`}
                  alt="doc6"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/doc/doc7.png`}
                  alt="doc6"
                  className="w-16 md:w-10 rounded-full ml-[-20px] md:ml-[-10px] shadow-md"
                />
              </Link>
            </div>
            <div className="text-right text-md sm:text-xs sm:text-center p-2">
              <p>
                منصة طبيبي هي منصة مخصصة للرعاية الصحية للمواطنين عن طريق أخذ
                مواعيد مع الاطباء دون عناء التنقل و يمكنك ايضا استشارة طبيب عن
                طريق تقنية الدردشة
              </p>
            </div>
            <div className="lg:hidden flex justify-center align-middle mt-16 mb-16 ">
              <button
                className="main-btn1 text-2xl"
                onClick={handleButtonClick}
              >
                احجز موعدك الآن
              </button>
            </div>
          </div>

          {/* Right Section */}
          <div className="hero-right rounded-b-2xl ">
            <div className="flex h-full w-full px-5 items-end justify-center ">
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}/images/hero01.png`}
                alt="Tabbibi"
                className="h-auto w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex hidden justify-center align-middle   ">
        <button
          className="main-btn1 relative mt-[-50px] mb-[150px] md:mt-[-180px]"
          onClick={handleButtonClick}
        >
          احجز موعد الآن
        </button>
      </div>
    </section>
  );
};

export default Hero;
